import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { colDefsMembersTable, Member } from './colDefsMembersTable';

export type MembersTableProps = {
  rowData: Member[];
  loading: boolean;
};

export const MembersTable = ({ rowData, loading }: MembersTableProps) => {
  const gridRef = useRef<AgGridReact<Member>>(null);
  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowHeight={55}
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        columnDefs={colDefsMembersTable}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressHorizontalScroll
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
